(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tradein-cart-bubble"] && !Shopify.designMode) return;
  try {
    class TradeInCartBubble extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      this.pydPageUrl = this.getAttribute('data-pyd-page') || '';
      this.pydCartIcon = this.getAttribute('data-pyd-cart-icon') || '';
      this.label = this.getAttribute('data-label') || 'Trade-in cart';

      // ensures icon persists in the header
      this.renderCart(window.tradeInCart || this.loadCartFromStorage() || { items: [] });

      // Update dynamically when event fires
      window.addEventListener('tradeIn:cartLoaded', (e) => this.renderCart(e.detail.cart));

      // watch for localStorage updates across tabs/windows
      window.addEventListener('storage', (e) => {
        if (e.key === 'tradein_cart' && e.newValue) {
          try {
            const cart = JSON.parse(e.newValue);
            this.renderCart(cart);
          } catch {}
        }
      });
    }
    loadCartFromStorage() {
      try {
        const stored = localStorage.getItem('tradein_cart');
        return stored ? JSON.parse(stored) : null;
      } catch {
        return null;
      }
    }

    renderCart(cart) {
      const items = Array.isArray(cart?.items) ? cart.items : [];
      this.innerHTML = this.renderBubble(items);
    }

    renderBubble(items) {
      const currentUrl = window.location.pathname.replace(/\/$/, '');
      const pydUrlPath = new URL(this.pydPageUrl, window.location.origin).pathname.replace(/\/$/, '');
      const isCartEmpty = items.length === 0;

      const countText = items.length === 1 ? '1 item' : `${items.length} items`;
      const accessibleLabel = isCartEmpty ? this.label : `${this.label}, ${countText}`;
      const linkStart = `<a class="tradein-cart-bubble__link header__icon" href="${this.pydPageUrl}" aria-label="${accessibleLabel}">`;

      const linkEnd = `</a>`;

      const iconSvg = `
        <div class="tradein-cart-bubble__icon" aria-hidden="true">
          ${this.pydCartIcon}
        </div>
      `;

      const countBadge = !isCartEmpty
        ? `
          <div class="tradein-cart-bubble__count" aria-hidden="true">
            ${items.length}
          </div>
        `
        : '';

      return `
        ${linkStart}
          ${iconSvg}
          ${countBadge}
        ${linkEnd}
      `;
    }
  }
  customElements.define('tradein-cart-bubble', TradeInCartBubble);
  } catch(e) { console.error(e); }
})();

})();
